(function () {
  const threadLibrary = window.HMCT_THREAD_LIBRARY || [];

  function initColorMatcher() {
    const upload = document.getElementById('hmctImageUpload');
    const workspace = document.getElementById('hmctWorkspace');
    const canvas = document.getElementById('hmctCanvas');
    const sampleInfo = document.getElementById('hmctSampleInfo');
    const sampleSwatch = document.getElementById('hmctSampleSwatch');
    const sampleHex = document.getElementById('hmctSampleHex');
    const emptyResults = document.getElementById('hmctEmptyResults');
    const results = document.getElementById('hmctResults');

    if (
      !upload ||
      !workspace ||
      !canvas ||
      !sampleInfo ||
      !sampleSwatch ||
      !sampleHex ||
      !emptyResults ||
      !results
    ) {
      return;
    }

    const ctx = canvas.getContext('2d', {
      willReadFrequently: true
    });

    let imageLoaded = false;

    upload.addEventListener('change', function (event) {
      const file = event.target.files && event.target.files[0];

      if (!file) return;

      if (!file.type.startsWith('image/')) {
        alert('Please choose an image file.');
        return;
      }

      const reader = new FileReader();

      reader.onload = function (readerEvent) {
        const img = new Image();

        img.onload = function () {
          const maxWidth = 1400;
          const scale = Math.min(
            1,
            maxWidth / img.naturalWidth
          );

          canvas.width = Math.round(
            img.naturalWidth * scale
          );

          canvas.height = Math.round(
            img.naturalHeight * scale
          );

          ctx.clearRect(
            0,
            0,
            canvas.width,
            canvas.height
          );

          ctx.drawImage(
            img,
            0,
            0,
            canvas.width,
            canvas.height
          );

          imageLoaded = true;

          workspace.classList.remove('hmct-hidden');
          sampleInfo.classList.add('hmct-hidden');
          results.classList.add('hmct-hidden');
          emptyResults.classList.remove('hmct-hidden');
        };

        img.src = readerEvent.target.result;
      };

      reader.readAsDataURL(file);
    });

    canvas.addEventListener('click', function (event) {
      if (!imageLoaded) return;

      const rect = canvas.getBoundingClientRect();

      const x = Math.floor(
        (event.clientX - rect.left) *
        (canvas.width / rect.width)
      );

      const y = Math.floor(
        (event.clientY - rect.top) *
        (canvas.height / rect.height)
      );

      const sampled = sampleAverageColor(
        ctx,
        canvas,
        x,
        y,
        3
      );

      const targetHex = rgbToHex(
        sampled.r,
        sampled.g,
        sampled.b
      );

      sampleSwatch.style.backgroundColor = targetHex;
      sampleHex.textContent = targetHex;
      sampleInfo.classList.remove('hmct-hidden');

      renderMatches(
        targetHex,
        results,
        emptyResults
      );
    });
  }

  function sampleAverageColor(
    ctx,
    canvas,
    centerX,
    centerY,
    radius
  ) {
    const startX = Math.max(
      0,
      centerX - radius
    );

    const startY = Math.max(
      0,
      centerY - radius
    );

    const endX = Math.min(
      canvas.width - 1,
      centerX + radius
    );

    const endY = Math.min(
      canvas.height - 1,
      centerY + radius
    );

    const width = endX - startX + 1;
    const height = endY - startY + 1;

    const pixels = ctx.getImageData(
      startX,
      startY,
      width,
      height
    ).data;

    let r = 0;
    let g = 0;
    let b = 0;
    let count = 0;

    for (let i = 0; i < pixels.length; i += 4) {
      if (pixels[i + 3] === 0) continue;

      r += pixels[i];
      g += pixels[i + 1];
      b += pixels[i + 2];
      count++;
    }

    if (!count) {
      return { r: 0, g: 0, b: 0 };
    }

    return {
      r: Math.round(r / count),
      g: Math.round(g / count),
      b: Math.round(b / count)
    };
  }

  function renderMatches(
    targetHex,
    results,
    emptyResults
  ) {
    const brands = [
      'Madeira',
      'ProWrap',
      'Fuji NOCP'
    ];

    const targetLab = hexToLab(targetHex);

    const matches = brands.map(function (brand) {
      const candidates = threadLibrary
        .filter(function (thread) {
          return thread.brand === brand;
        })
        .map(function (thread) {
          return {
            brand: thread.brand,
            number: thread.number,
            name: thread.name,
            hex: thread.hex,
            distance: deltaE2000(
              targetLab,
              hexToLab(thread.hex)
            )
          };
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        });

      return candidates[0];
    }).filter(Boolean);

    results.innerHTML = matches.map(function (match) {
      const commerce = getCommerceInfo(match);

      return `
        <div class="hmct-result-card">

          <span
            class="hmct-result-swatch"
            style="background-color: ${match.hex};"
            aria-hidden="true"
          >&nbsp;</span>

          <div class="hmct-result-info">
            <p class="hmct-result-brand">
              ${match.brand}
            </p>

            <p class="hmct-result-name">
              ${match.name}
            </p>

            <p class="hmct-result-meta">
              #${match.number} · ${match.hex}
            </p>

            ${commerce}
          </div>

        </div>
      `;
    }).join('');

    emptyResults.classList.add('hmct-hidden');
    results.classList.remove('hmct-hidden');
  }

  function getCommerceInfo(match) {
    if (match.brand === 'Madeira') {
      return getMadeiraCommerceInfo(match);
    }

    if (match.brand === 'Fuji NOCP') {
      return getFujiCommerceInfo(match);
    }

    return '';
  }

  function getMadeiraCommerceInfo(match) {
    const madeiraMatch = findMadeiraVariant(match.number);

    if (!madeiraMatch) {
      return `
        <p class="hmct-result-stock-note">
          This Madeira color is not currently linked to an HMCT product.
        </p>
      `;
    }

    if (!madeiraMatch.variant.available) {
      return `
        <p class="hmct-result-stock-note">
          Currently unavailable
        </p>
      `;
    }

    const productUrl =
      madeiraMatch.product.url ||
      '/products/' + madeiraMatch.product.handle;

    const separator = productUrl.indexOf('?') === -1
      ? '?'
      : '&';

    const shopUrl =
      productUrl +
      separator +
      'variant=' +
      madeiraMatch.variant.id;

    return `
      <a
        class="hmct-shop-button"
        href="${shopUrl}"
        target="_blank"
        rel="noopener noreferrer"
      >
        Shop This Color
      </a>
    `;
  }

  function getFujiCommerceInfo(match) {
    const fujiMatches = findFujiProducts(match.number);

    const links = [];

    if (fujiMatches.A) {
      links.push(buildFujiShopLink('A', fujiMatches.A));
    }

    if (fujiMatches.D) {
      links.push(buildFujiShopLink('D', fujiMatches.D));
    }

    if (links.length === 0) {
      return `
        <p class="hmct-result-stock-note">
          Not currently stocked by HMCT
        </p>
      `;
    }

    return `
      <div class="hmct-fuji-shop-links">
        ${links.join('&nbsp;&nbsp;')}
      </div>
    `;
  }

  function buildFujiShopLink(size, match) {
    let shopUrl =
      match.product.url ||
      '/products/' + match.product.handle;

    if (match.variant && match.variant.id) {
      const separator = shopUrl.indexOf('?') === -1
        ? '?'
        : '&';

      shopUrl +=
        separator +
        'variant=' +
        match.variant.id;
    }

    return `
      <a
        class="hmct-shop-button"
        href="${shopUrl}"
        target="_blank"
        rel="noopener noreferrer"
      >
        Shop ${size} Size
      </a>
    `;
  }

  function findMadeiraVariant(threadNumber) {
    const products =
      window.HMCT_MADEIRA_PRODUCTS || [];

    const wanted = normalizeThreadNumber(threadNumber);

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      const variants = product.variants || [];

      for (let j = 0; j < variants.length; j++) {
        const variant = variants[j];

        const values = [
          variant.title,
          variant.sku
        ].concat(variant.options || []);

        const exactMatch = values.some(function (value) {
          return normalizeThreadNumber(value) === wanted;
        });

        if (exactMatch) {
          return {
            product: product,
            variant: variant
          };
        }
      }
    }

    return null;
  }

  function findFujiProducts(threadNumber) {
    const products =
      window.HMCT_FUJI_PRODUCTS || [];

    const wanted = normalizeThreadNumber(threadNumber);

    const found = {
      A: null,
      D: null
    };

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      const variants = product.variants || [];

      const productValues = [
        product.title,
        product.handle
      ];

      const productNumberMatch = productValues.some(function (value) {
        return containsThreadNumber(value, wanted);
      });

      for (let j = 0; j < variants.length; j++) {
        const variant = variants[j];

        const allValues = productValues.concat([
          variant.title,
          variant.sku
        ]).concat(variant.options || []);

        const numberMatch =
          productNumberMatch ||
          allValues.some(function (value) {
            return containsThreadNumber(value, wanted);
          });

        if (!numberMatch || !variant.available) {
          continue;
        }

        const size = detectFujiSize(allValues);

        if (size && !found[size]) {
          found[size] = {
            product: product,
            variant: variant
          };
        }
      }
    }

    return found;
  }

  function containsThreadNumber(value, wanted) {
    if (value === null || value === undefined) {
      return false;
    }

    const tokens = String(value)
      .toUpperCase()
      .split(/[^A-Z0-9]+/)
      .filter(Boolean);

    return tokens.indexOf(wanted) !== -1;
  }

  function detectFujiSize(values) {
    const text = values
      .filter(function (value) {
        return value !== null && value !== undefined;
      })
      .join(' ')
      .toUpperCase();

    if (
      /(^|[^A-Z0-9])A[\s_-]*THREAD([^A-Z0-9]|$)/.test(text) ||
      /(^|[^A-Z0-9])A[\s_-]*SIZE([^A-Z0-9]|$)/.test(text) ||
      /(^|[^A-Z0-9])A([^A-Z0-9]|$)/.test(text)
    ) {
      return 'A';
    }

    if (
      /(^|[^A-Z0-9])D[\s_-]*THREAD([^A-Z0-9]|$)/.test(text) ||
      /(^|[^A-Z0-9])D[\s_-]*SIZE([^A-Z0-9]|$)/.test(text) ||
      /(^|[^A-Z0-9])D([^A-Z0-9]|$)/.test(text)
    ) {
      return 'D';
    }

    return null;
  }

  function normalizeThreadNumber(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value)
      .trim()
      .replace(/^#/, '')
      .toUpperCase();
  }

  function rgbToHex(r, g, b) {
    return '#' + [r, g, b]
      .map(function (value) {
        return value
          .toString(16)
          .padStart(2, '0');
      })
      .join('')
      .toUpperCase();
  }

  function hexToRgb(hex) {
    const clean = hex.replace('#', '');

    return {
      r: parseInt(clean.substring(0, 2), 16),
      g: parseInt(clean.substring(2, 4), 16),
      b: parseInt(clean.substring(4, 6), 16)
    };
  }

  function hexToLab(hex) {
    const rgb = hexToRgb(hex);

    let r = rgb.r / 255;
    let g = rgb.g / 255;
    let b = rgb.b / 255;

    r = r > 0.04045
      ? Math.pow((r + 0.055) / 1.055, 2.4)
      : r / 12.92;

    g = g > 0.04045
      ? Math.pow((g + 0.055) / 1.055, 2.4)
      : g / 12.92;

    b = b > 0.04045
      ? Math.pow((b + 0.055) / 1.055, 2.4)
      : b / 12.92;

    let x =
      (
        r * 0.4124 +
        g * 0.3576 +
        b * 0.1805
      ) / 0.95047;

    let y =
      (
        r * 0.2126 +
        g * 0.7152 +
        b * 0.0722
      ) / 1.00000;

    let z =
      (
        r * 0.0193 +
        g * 0.1192 +
        b * 0.9505
      ) / 1.08883;

    x = x > 0.008856
      ? Math.pow(x, 1 / 3)
      : (7.787 * x) + (16 / 116);

    y = y > 0.008856
      ? Math.pow(y, 1 / 3)
      : (7.787 * y) + (16 / 116);

    z = z > 0.008856
      ? Math.pow(z, 1 / 3)
      : (7.787 * z) + (16 / 116);

    return {
      L: (116 * y) - 16,
      a: 500 * (x - y),
      b: 200 * (y - z)
    };
  }

  function deltaE2000(lab1, lab2) {
    const L1 = lab1.L;
    const a1 = lab1.a;
    const b1 = lab1.b;

    const L2 = lab2.L;
    const a2 = lab2.a;
    const b2 = lab2.b;

    const avgL = (L1 + L2) / 2;

    const C1 = Math.sqrt(
      a1 * a1 + b1 * b1
    );

    const C2 = Math.sqrt(
      a2 * a2 + b2 * b2
    );

    const avgC = (C1 + C2) / 2;

    const pow25To7 = Math.pow(25, 7);

    const G =
      0.5 *
      (
        1 -
        Math.sqrt(
          Math.pow(avgC, 7) /
          (
            Math.pow(avgC, 7) +
            pow25To7
          )
        )
      );

    const a1Prime = (1 + G) * a1;
    const a2Prime = (1 + G) * a2;

    const C1Prime = Math.sqrt(
      a1Prime * a1Prime +
      b1 * b1
    );

    const C2Prime = Math.sqrt(
      a2Prime * a2Prime +
      b2 * b2
    );

    const avgCPrime =
      (C1Prime + C2Prime) / 2;

    const h1Prime = hueAngle(
      b1,
      a1Prime
    );

    const h2Prime = hueAngle(
      b2,
      a2Prime
    );

    const deltaLPrime = L2 - L1;
    const deltaCPrime =
      C2Prime - C1Prime;

    let deltahPrime;

    if (C1Prime * C2Prime === 0) {
      deltahPrime = 0;
    } else if (
      Math.abs(h2Prime - h1Prime) <= 180
    ) {
      deltahPrime =
        h2Prime - h1Prime;
    } else if (h2Prime <= h1Prime) {
      deltahPrime =
        h2Prime -
        h1Prime +
        360;
    } else {
      deltahPrime =
        h2Prime -
        h1Prime -
        360;
    }

    const deltaHPrime =
      2 *
      Math.sqrt(
        C1Prime * C2Prime
      ) *
      Math.sin(
        degreesToRadians(
          deltahPrime / 2
        )
      );

    let avgHPrime;

    if (C1Prime * C2Prime === 0) {
      avgHPrime =
        h1Prime + h2Prime;
    } else if (
      Math.abs(
        h1Prime - h2Prime
      ) <= 180
    ) {
      avgHPrime =
        (h1Prime + h2Prime) / 2;
    } else if (
      h1Prime + h2Prime < 360
    ) {
      avgHPrime =
        (
          h1Prime +
          h2Prime +
          360
        ) / 2;
    } else {
      avgHPrime =
        (
          h1Prime +
          h2Prime -
          360
        ) / 2;
    }

    const T =
      1
      - 0.17 * Math.cos(
        degreesToRadians(
          avgHPrime - 30
        )
      )
      + 0.24 * Math.cos(
        degreesToRadians(
          2 * avgHPrime
        )
      )
      + 0.32 * Math.cos(
        degreesToRadians(
          3 * avgHPrime + 6
        )
      )
      - 0.20 * Math.cos(
        degreesToRadians(
          4 * avgHPrime - 63
        )
      );

    const deltaTheta =
      30 *
      Math.exp(
        -Math.pow(
          (avgHPrime - 275) / 25,
          2
        )
      );

    const RC =
      2 *
      Math.sqrt(
        Math.pow(avgCPrime, 7) /
        (
          Math.pow(avgCPrime, 7) +
          pow25To7
        )
      );

    const SL =
      1 +
      (
        0.015 *
        Math.pow(
          avgL - 50,
          2
        )
      ) /
      Math.sqrt(
        20 +
        Math.pow(
          avgL - 50,
          2
        )
      );

    const SC =
      1 +
      0.045 * avgCPrime;

    const SH =
      1 +
      0.015 *
      avgCPrime *
      T;

    const RT =
      -Math.sin(
        degreesToRadians(
          2 * deltaTheta
        )
      ) *
      RC;

    const termL =
      deltaLPrime / SL;

    const termC =
      deltaCPrime / SC;

    const termH =
      deltaHPrime / SH;

    return Math.sqrt(
      termL * termL +
      termC * termC +
      termH * termH +
      RT * termC * termH
    );
  }

  function hueAngle(b, aPrime) {
    if (
      aPrime === 0 &&
      b === 0
    ) {
      return 0;
    }

    let angle =
      Math.atan2(
        b,
        aPrime
      ) *
      (180 / Math.PI);

    if (angle < 0) {
      angle += 360;
    }

    return angle;
  }

  function degreesToRadians(degrees) {
    return degrees *
      (Math.PI / 180);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initColorMatcher
    );
  } else {
    initColorMatcher();
  }
})();